<template>
  <div>
    <div class="mb-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
      <h2
        class="lg:col-span-6 lg:col-start-4 mb-0 text-4xl font-bold text-center leading-tight uppercase"
      >
        {{
          currentNewsType.key === 'all'
            ? t('news/title')
            : currentNewsType.label
        }}
      </h2>
      <div class="lg:col-span-3 flex justify-end items-center">
        <form-dropdown
          class="w-full"
          :label="t('landingpage/index/games/sort_by')"
          :items="newsTypeOptions"
          :item-class="'text-capitalize'"
          :value="currentNewsType"
          @change="selectNewsType"
        />
      </div>
    </div>
    <news-grid
      v-if="news.length > 0"
      class="mb-8"
      :articles="news"
      top-article-has-full-width-mobile
    />
    <div class="flex justify-center">
      <common-button :to="allNewsLink" size="sm">
        {{
          t('homePage/to_all', {
            context: t('general/non_special_texts/news_plural'),
          })
        }}
      </common-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { captureException } from '@sentry/nuxt';
import {
  GetNewsArticles,
  type GetNewsArticlesQuery,
  type GetNewsArticlesQueryVariables,
  type StrapiArticle,
} from '~/apollo/types/types';
import type SelectItem from '~/components/form/dropdown/types';
import { useNewsTypes } from '~/components/news/features/useNewsTypes';

const { locale, t } = useI18n();
const allNewsLink = computed<string>(() => `/${locale.value}/news`);

const { newsTypeOptions, currentNewsType, currentNewsTypeForGql } =
  useNewsTypes();

const { data: news } = await useAsyncData(
  `gp-home-page-news-${locale.value}-${currentNewsTypeForGql.value}`,
  async () => {
    try {
      const { error, data } = await useLegacyApollo<
        GetNewsArticlesQuery,
        GetNewsArticlesQueryVariables
      >(GetNewsArticles, {
        locale: locale.value,
        type: currentNewsTypeForGql.value,
        limit: 4,
        offset: 0,
      });

      if (error == null && data != null) {
        return data.articles as Array<StrapiArticle>;
      }
      if (error != null) {
        captureException(error);
      }
    } catch (error) {
      captureException(error);
    }

    return [];
  },
  {
    watch: [locale, currentNewsTypeForGql],
  },
);

const selectNewsType = (val: SelectItem) => {
  currentNewsType.value = val;
};
</script>
